import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Divider,
  Stack
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import { Button } from '@mui/material';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 6 }}>
      <Button
        startIcon={<ArrowBack />}
        onClick={() => navigate(-1)}
        variant="outlined"
        sx={{ mb: 3 }}
      >
        Retour
      </Button>

      <Paper sx={{ p: { xs: 3, md: 6 }, mb: 4 }}>
        <Typography variant="h3" gutterBottom sx={{ fontWeight: 700, mb: 3 }}>
          Conditions d'Utilisation
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
        </Typography>

        <Divider sx={{ mb: 4 }} />

        <Stack spacing={4}>
          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              1. Acceptation des conditions
            </Typography>
            <Typography variant="body1" paragraph>
              En accédant et en utilisant Tchamba Marketplace, vous acceptez d'être lié par les présentes Conditions d'Utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser notre plateforme.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              2. Description du service
            </Typography>
            <Typography variant="body1" paragraph>
              Tchamba Marketplace est une plateforme e-commerce qui permet aux utilisateurs de :
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              <ul>
                <li>Parcourir et rechercher des produits, services et annonces</li>
                <li>Créer un compte utilisateur ou vendeur</li>
                <li>Publier des produits, services et annonces (pour les vendeurs)</li>
                <li>Contacter les vendeurs via WhatsApp ou téléphone</li>
                <li>Accéder à des produits et services exclusifs VIP</li>
              </ul>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              3. Inscription et compte utilisateur
            </Typography>
            <Typography variant="body1" paragraph>
              Pour utiliser certaines fonctionnalités de la plateforme, vous devez créer un compte. Vous vous engagez à :
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              <ul>
                <li>Fournir des informations exactes, complètes et à jour</li>
                <li>Maintenir la sécurité de votre compte et de votre mot de passe</li>
                <li>Être responsable de toutes les activités sous votre compte</li>
                <li>Notifier immédiatement toute utilisation non autorisée de votre compte</li>
                <li>Respecter l'âge minimum requis (18 ans ou avec autorisation parentale)</li>
              </ul>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              4. Comportement des utilisateurs
            </Typography>
            <Typography variant="body1" paragraph>
              Vous vous engagez à ne pas :
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              <ul>
                <li>Utiliser la plateforme à des fins illégales ou frauduleuses</li>
                <li>Publier du contenu offensant, diffamatoire ou illégal</li>
                <li>Violer les droits de propriété intellectuelle d'autrui</li>
                <li>Transmettre des virus ou codes malveillants</li>
                <li>Tenter d'accéder de manière non autorisée au système</li>
                <li>Harceler, menacer ou nuire à d'autres utilisateurs</li>
                <li>Utiliser des robots ou scripts automatisés</li>
                <li>Vendre des produits contrefaits ou interdits</li>
              </ul>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              5. Contenu utilisateur
            </Typography>
            <Typography variant="body1" paragraph>
              En publiant du contenu sur notre plateforme, vous :
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              <ul>
                <li>Conservez la propriété de votre contenu</li>
                <li>Nous accordez une licence pour utiliser, afficher et distribuer votre contenu sur la plateforme</li>
                <li>Garantissez que vous avez le droit de publier ce contenu</li>
                <li>Acceptez que nous puissions modérer ou supprimer tout contenu inapproprié</li>
              </ul>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              6. Transactions et paiements
            </Typography>
            <Typography variant="body1" paragraph>
              Les transactions entre acheteurs et vendeurs sont gérées directement entre les parties. Tchamba Marketplace :
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              <ul>
                <li>N'est pas partie aux transactions entre utilisateurs</li>
                <li>Ne garantit pas la qualité, la sécurité ou la légalité des produits vendus</li>
                <li>N'est pas responsable des litiges entre acheteurs et vendeurs</li>
                <li>Se réserve le droit de suspendre ou supprimer des comptes en cas de non-respect des conditions</li>
              </ul>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              7. Propriété intellectuelle
            </Typography>
            <Typography variant="body1" paragraph>
              Tous les contenus de la plateforme (logos, textes, graphiques, etc.) sont la propriété de Tchamba Marketplace ou de ses partenaires. Vous ne pouvez pas :
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              <ul>
                <li>Reproduire, copier ou distribuer le contenu sans autorisation</li>
                <li>Utiliser nos marques ou logos sans permission écrite</li>
                <li>Modifier ou créer des œuvres dérivées basées sur notre contenu</li>
              </ul>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              8. Limitation de responsabilité
            </Typography>
            <Typography variant="body1" paragraph>
              Tchamba Marketplace est fourni "tel quel". Nous ne garantissons pas :
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              <ul>
                <li>L'exactitude, l'exhaustivité ou l'actualité des informations</li>
                <li>L'absence d'interruptions ou d'erreurs</li>
                <li>La sécurité absolue des données</li>
                <li>La disponibilité permanente du service</li>
              </ul>
            </Typography>
            <Typography variant="body1" paragraph sx={{ mt: 2 }}>
              Dans la mesure permise par la loi, nous ne serons pas responsables des dommages directs, indirects, accessoires ou consécutifs résultant de l'utilisation de la plateforme.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              9. Suspension et résiliation
            </Typography>
            <Typography variant="body1" paragraph>
              Nous nous réservons le droit de :
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              <ul>
                <li>Suspendre ou résilier votre compte en cas de violation des présentes conditions</li>
                <li>Supprimer tout contenu jugé inapproprié</li>
                <li>Modifier ou interrompre le service à tout moment</li>
                <li>Refuser l'accès à la plateforme sans préavis</li>
              </ul>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              10. Modifications des conditions
            </Typography>
            <Typography variant="body1" paragraph>
              Nous nous réservons le droit de modifier ces Conditions d'Utilisation à tout moment. Les modifications seront publiées sur cette page avec une date de mise à jour révisée. Votre utilisation continue de la plateforme après les modifications constitue votre acceptation des nouvelles conditions.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              11. Droit applicable et juridiction
            </Typography>
            <Typography variant="body1" paragraph>
              Les présentes Conditions d'Utilisation sont régies par les lois du Togo. Tout litige sera soumis à la juridiction exclusive des tribunaux compétents de Tchamba, Togo.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              12. Contact
            </Typography>
            <Typography variant="body1" paragraph>
              Pour toute question concernant ces Conditions d'Utilisation, veuillez nous contacter :
            </Typography>
            <Typography variant="body1" paragraph sx={{ pl: 2 }}>
              <strong>Email :</strong> contact@tchambamarketplace.com<br />
              <strong>Adresse :</strong> Tchamba, Togo<br />
              <strong>Page de contact :</strong> <a href="/contact" style={{ color: 'inherit' }}>/contact</a>
            </Typography>
          </Box>
        </Stack>
      </Paper>
    </Container>
  );
};

export default TermsOfService;

